import ActivityIcon from '@/components/icons/activity';
import ClockIcon from '@/components/icons/clock';
import FormTemplateIcon from '@/components/icons/form-template';
import SpannerIcon from '@/components/icons/spanner';
import { TopbarTab } from '@/components/topbar/topbar';
import { getWorkspaceRoute } from '@/utils/routes';

export function TopbarActions() {
  return (
    <div className="flex h-full items-center">
      <TopbarTab href={getWorkspaceRoute('/schedules/checks')} label="Schedule Checks" icon={<SpannerIcon />} />
      <TopbarTab href={getWorkspaceRoute('/schedules/activity')} label="Schedule Activity" icon={<ActivityIcon />} />
      <TopbarTab href={getWorkspaceRoute('/schedules')} label="Schedules" icon={<ClockIcon />} />
      <TopbarTab href={getWorkspaceRoute('/schedules/forms')} label="Schedule Forms" icon={<FormTemplateIcon />} active />
    </div>
  );
}
